export function isSafeHttpUrl(value: string): boolean {
  const input = value.trim();
  if (!input) {
    return false;
  }

  try {
    const url = new URL(input);
    return url.protocol === "http:" || url.protocol === "https:";
  } catch {
    return false;
  }
}

const AMAZON_HOST_PATTERN = /(^|\.)amazon\.[a-z.]+$/i;
const AMAZON_AFFILIATE_TAG_PATTERN = /^[A-Za-z0-9-]{3,64}$/;

export function enforceAmazonAffiliateTag(value: string, tag?: string): string {
  const input = value.trim();
  if (!isSafeHttpUrl(input)) {
    return input;
  }

  const normalizedTag = normalizeAmazonAffiliateTag(tag);
  if (!normalizedTag) {
    return input;
  }

  try {
    const url = new URL(input);
    if (!isAmazonHostname(url.hostname)) {
      return url.toString();
    }

    url.searchParams.set("tag", normalizedTag);
    return url.toString();
  } catch {
    return input;
  }
}

export function normalizeAmazonAffiliateTag(value: string | null | undefined): string | undefined {
  if (typeof value !== "string") {
    return undefined;
  }

  const normalized = value.trim();
  if (!normalized || !AMAZON_AFFILIATE_TAG_PATTERN.test(normalized)) {
    return undefined;
  }

  return normalized;
}

export function isAmazonHostname(hostname: string): boolean {
  const normalized = hostname.trim().toLocaleLowerCase();
  return AMAZON_HOST_PATTERN.test(normalized);
}
